export class SquareLoyaltyApiError extends Error {
  code: SquareErrorCode;

  constructor({ message, code }: { message: string; code: SquareErrorCode }) {
    super(message);
    this.code = code;
  }
}

export enum CommonErrorCode {
  AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR',
  NOT_FOUND = 'NOT_FOUND',
  OTHER = 'OTHER',
}

export enum EnrollmentErrorCode {
  DUPLICATE_PHONE_NUMBER = 'DUPLICATE_PHONE_NUMBER',
  INVALID_PHONE_NUMBER = 'INVALID_PHONE_NUMBER',
}

export type SquareErrorCode = CommonErrorCode | EnrollmentErrorCode;
